export default "__VITE_ASSET__DbrpeMbL__"